import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Followup = ({ show, onClose, selectedId, refresh, count, data }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
   
    const [leadTypeOptions, setLeadTypeOptions] = useState([]);
    const [lead_type, setLeadtype] = useState(null);
    useEffect(() => {
        const fetchLeadTypes = async () => {
            try {
                const response = await axios.get(`${baseURL}/getleadtype`);
                const formatted = response.data.data.filter(item => item.sno !== data.lead_type && item.sno !== 1 && item.sno !== 4).map(item => ({
                    value: item.sno,
                    label: item.leadtype_name,
                }));
                setLeadTypeOptions(formatted);
            } catch (error) {
                console.log('Error fetching lead types:', error);
            }
        };

        fetchLeadTypes();
    }, []);


    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};

        if(!lead_type){
            newErrors.typ = "This Field is Required.";
        }

        return newErrors;
    };
    
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const handleSubmit = (event) => {
        event.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { 
            lead_type: lead_type,
            created_by: user_id,
            branch_id: branch_id
        };
        axios.post(`${baseURL}/managelead/convert_lead/${selectedId}`, postData)
            .then(response => {
                onClose();
                refresh();
                count();
                toast.success("Lead Converted Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Lead Convertion Failed");
            });
    };

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Service Type</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className='col-lg-12 mb-3'>
                                <div className="row">
                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                                        <label className='text-gray-800 font-w500 fs-7'>Lead</label>
                                        <label className='text-black fs-6 font-w500'>{data.lead_name}</label>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                                        <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                                        <label className='text-black fs-6 font-w500'>{data.mobile_no}</label>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                                        <label className='text-gray-800 font-w500 fs-7'>Registration Date</label>
                                        <label className='text-black fs-6 font-w500'>{formatDate(data.formatted_date)}</label>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                                        <label className='text-gray-800 font-w500 fs-7'>Lead Type</label>
                                        <label className='text-black fs-6 font-w500'>{data.lead_type_name}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label className="text-black font-w500 fs-7">Service Type<span className="required">*</span></label>
                                <Select  placeholder="Select Service Type"
                                    options={leadTypeOptions}
                                    onChange={(selectedOption) => setLeadtype(selectedOption?.value || '')}
                                />
                                {errors.typ && <div className="text-danger fs-8 mt-1">{errors.typ}</div>}
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                            <button type="submit" className="btn btn-sm btn-primary">Convert Lead <i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default Followup;
